import { useEffect, useRef, useState } from "react";

export default function Testimonial() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="testimonial"
      ref={sectionRef}
      className="bg-cream py-24 md:py-36 px-6"
    >
      <div className="max-w-3xl mx-auto">

        {/* Label */}
        <p
          className="font-sans text-xs tracking-widest2 uppercase text-terracotta mb-12 text-center transition-all duration-700 ease-out"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "0ms",
          }}
        >
          A Client&apos;s Words
        </p>

        {/* Quote */}
        <blockquote className="relative">
          {/* Decorative quote mark */}
          <span
            className="absolute -top-1 -left-1 md:-left-4 font-serif text-2xl md:text-6xl text-terracotta/20 leading-none select-none transition-all duration-700 ease-out"
            aria-hidden="true"
            style={{
              opacity: visible ? 1 : 0,
              transitionDelay: "100ms",
            }}
          >
            &ldquo;
          </span>

          <p
            className="font-serif text-2xl md:text-3xl lg:text-4xl font-light text-ink leading-relaxed relative z-10 transition-all duration-700 ease-out"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? "translateY(0)" : "translateY(20px)",
              transitionDelay: "150ms",
            }}
          >
            If you are looking for someone to guide you through a life-altering
            cancer diagnosis, Krystal is your girl. She helped me step back
            through my tears and see just a sliver of light in a very dark time.
            She offered perspective when I couldn&apos;t think straight —
            encouragement, positivity, and compassion in an impossible time.
          </p>

          <p
            className="font-serif text-xl md:text-2xl font-light text-ink/70 mt-6 leading-relaxed relative z-10 transition-all duration-700 ease-out"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? "translateY(0)" : "translateY(20px)",
              transitionDelay: "300ms",
            }}
          >
            She is a true gem, and you would be amiss to not work with her.
          </p>

          {/* Attribution */}
          <footer
            className="mt-10 flex items-center gap-4 transition-all duration-700 ease-out"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? "translateY(0)" : "translateY(12px)",
              transitionDelay: "450ms",
            }}
          >
            <div className="w-8 h-px bg-terracotta" />
            <cite className="font-sans text-xs tracking-widest uppercase text-ink/60 not-italic">
              Robin S.
            </cite>
          </footer>
        </blockquote>

      </div>
    </section>
  );
}
